import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntPasswordInputComponent} from "./int-password-input.component";
import {IntDefaultInputModule} from "../int-default-input";
import {IntIconModule} from "../../int-icon";

@NgModule({
  imports: [
    CommonModule,
    IntDefaultInputModule,
    IntIconModule
  ],
  declarations: [
    IntPasswordInputComponent
  ],
  exports: [
    IntPasswordInputComponent
  ]
})
export class IntPasswordInputModule {}
